/* Make flag names more readable */
export const getPrettyFeatureFlagName = (name?: string) =>
  name?.replace(/_/g, " ")?.replace("FEATURE ", "")?.toLocaleLowerCase();
